import React from 'react';

import {NotepadAvatar} from 'ccm/art/MedicalIcons';

import InfoCard from './InfoCard';

export default function CarePlansCard(props) {
    return (
        <InfoCard
            color='blue'
            Avatar={NotepadAvatar}
            title='Care Plans'
            {...props}
        ></InfoCard>
    );
}
